<template lang="pug">
	div
		#sfc-main-container.what-is-layout-v4-top-bottom-banners.sfc-container-redesign-v1(v-bind:class="{'userIsLoggedIn' : userSubscribed()}")
			sfc-sentry
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-login
			sfc-forgot-password
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header
			main#sfc-main-content(role="main" :class="{'no-margin-top': !userSubscribed()}")
				nuxt
			no-ssr(v-if="!userSubscribed()")
				b-row#bottom-ad
					.col-md-12.col-sm-12.col-xs-12.ad-align-center
						.bottom-banner(style="")
							sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
			no-ssr
				sfc-modal-trigger
			no-ssr
				enroll-now-modal
		no-ssr
			sfc-college-savings-questions-modal
		no-ssr
			sfc-mobile-conversion-bar-ad
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
>>> #what-is-flow
	.sidebar-container
		a
			text-decoration: none !important
		p
			font-size: body-font-size-sm
		.more-articles
			color: sfc-blue-hover
			text-decoration: underline
		.main-table-container
			.tabs
				a
					&.tab
						color: body-font-color !important
			table
				&.table
					tr:nth-child(2n)
						background: transparent !important
			p
				font-size: body-font-size
			a
				color: body-font-color
				&:hover
					color: sfc-blue-hover
			.view-full-list
				text-decoration: underline !important
				color: body-font-color
				margin-top: 20px
				margin-bottom: 60px

	#bottom-ad
		background: bg-dark-gray
		.bottom-banner
			padding: 15px 0
	#bottom-ad
		background: bg-dark-gray
		.bottom-banner
			padding: 15px 0

</style>

<script>
import SfcHeader from '@/layouts/common/sfc-header-slim'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcModalTrigger from '@/common/components/modals/modal-trigger'
import EnrollNowModal from '@/common/components/modals/enroll-now-modal'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'
import SfcMobileConversionBarAd from '@/common/components/sfc-mobile-conversion-bar-ad'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		SfcModalTrigger,
		sfcCollegeSavingsQuestionsModal,
		EnrollNowModal,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2,
		SfcMobileConversionBarAd
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
